// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import MenuDefaultProps from "@insite/mobius/Menu/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@vanmeter/XDL/constants";
import ChevronRight from "@vanmeter/XDL/Icons/IconAngleRightSmall";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color, styledScrollbar } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...MenuDefaultProps,
        mergeCss: true,
        moreIconProps: {
            src: ChevronRight,
            width: 7,
            height: 18,
            color: "common.ui5",
            css: css`
                position: absolute;
                right: 12px;
                transform: translateY(-50%);
                top: 50%;
            `,
        },
        menuItemTypographyProps: {
            ...fontConfig.smallSingleLine,
            weight: fontConfig.weight.regular,
        },
        cssOverrides: {
            menu: css`
                max-height: 66vh;
                box-shadow: -1px 0 0 0 ${color("common.border")};
                ${styledScrollbar()}

                &:not(:has(> .MenuItem ${StyledButton}:hover)) > .MenuItem[data-open] {
                    background: ${color("common.ui16")};

                    ${TypographyStyle}, ${IconWrapper} {
                        color: ${color("common.ui1")};
                    }
                }

                &:has(> .MenuItem ${StyledButton}:hover) > .MenuItem[data-open]:not(:hover) {
                    background: ${color("common.white")};

                    ${StyledButton} {
                        background: ${color("common.white")};
                    }

                    ${TypographyStyle}, ${IconWrapper} {
                        color: ${color("text.main")};
                    }
                }

                ${({ referenceIndex }: any) => {
                    if (referenceIndex === 0) {
                        return css`
                            width: 445px;
                            position: relative;
                            &:after {
                                content: "";
                                position: absolute;
                                width: 1px;
                                height: 100%;
                                background: ${color("common.border")};
                                top: 0;
                                right: 0;
                            }
                        `;
                    }
                    return css`
                        width: 324px;
                    `;
                }}
            `,
            menuItem: css`
                ${StyledButton} {
                    padding: 10px 12px;
                    min-height: initial;
                    &:hover {
                        background: ${color("common.ui15")};

                        ${TypographyStyle}, ${IconWrapper} {
                            color: ${color("common.ui1")};
                        }
                    }
                }
            `,
        },
    },
} as xBaseTheme["menu"];
